// @flow
import * as React from 'react';
import DateTimePicker from 'components/DateTimePicker';
import Field from './Field';

const DateTimePickerField = ({
  name,
  label,
  description,
  ...props
}: {
  name: string,
  label?: string,
  description?: string
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <DateTimePicker
        id={id}
        name={name}
        value={value}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={updateValue}
        {...props}
      />
    )}
  />
);

export default DateTimePickerField;
